import { n as ok, t as err } from "./result-D_NYcfr2.js";
import { attempt } from "es-toolkit";
//#region src/json.ts
const JSON_INDENT = 2;
/**
* Parse a JSON string into an unknown value, returning a {@link Result} instead of throwing.
*
* @param raw - The JSON string to parse.
* @returns A Result tuple with the parsed value or an error message.
*/
function jsonParse(raw) {
	const [error, value] = attempt(() => JSON.parse(raw));
	if (error) return err(`Failed to parse JSON: ${error.message}`);
	return ok(value);
}
/**
* Serialize a value to a JSON string, returning a {@link Result} instead of throwing.
*
* @param data - The value to serialize.
* @param options - Serialization options.
* @returns A Result tuple with the JSON string or an error message.
*/
function jsonStringify(data, options = {}) {
	const { pretty = false } = options;
	const [error, value] = attempt(() => {
		if (pretty) return JSON.stringify(data, null, JSON_INDENT);
		return JSON.stringify(data);
	});
	if (error) return err(`Failed to stringify JSON: ${error.message}`);
	return ok(value);
}
//#endregion
export { jsonParse, jsonStringify };

//# sourceMappingURL=json.js.map